<script>
// Componente para apresentar a análise do portfólio
import MinhaCarteira from '@views/minha-carteira'
import Vue from 'vue'
import { GlobalBus } from '@services/bus'
import Title from '@components/section-title'
import { MODAL } from '@constants/Text'

export default {
  components: { MinhaCarteira, Title },
  props: {
    // Controle de eventos baseado na left-bar
    busLeft: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      // Controle de eventos do componente da análise
      bus: new Vue(),
      // Controle de eventos para o componente de modal
      busModal: new Vue(),
      /**
       * Cliente a ser visualizado
       * @param id
       * @param id_cadastro_cliente
       * @param name
       * @param login
       * @param id_cliente_web
       */
      cliente: null,
    }
  },
  created() {
    GlobalBus.$on(MODAL.MODAL_MY_WALLET, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.MODAL_MY_WALLET, this.open)
  },
  methods: {
    /**
     * Abrir modal
     */
    open(cliente) {
      this.cliente = cliente
      this.selectClient(cliente)
      this.busModal.$emit('dialog', true)

      this.$nextTick(() => {
        GlobalBus.$emit('changeClient')
      })
    },
    selectClient(cliente) {
      if (!cliente || !cliente.id) return
      this.$store.dispatch('user/addSearchClient', {
        id: cliente.id,
        id_cadastro_cliente: cliente.id_cadastro_cliente,
        name: cliente.nome_cliente || cliente.name || '',
      })
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="calc(100vw - 135px)">
    <Title title="Carteira atual" :subtitle="cliente ? cliente.name : ''" />
    <MinhaCarteira :bus-left="busLeft" :bus="bus" :cliente-modal="cliente" />

    <template v-slot:actions>
      <v-spacer />
      <!-- <BaseButton underlined>
        Cancelar
      </BaseButton>
      <BaseButton primary>
        Enviar
      </BaseButton> -->
      <v-spacer />
    </template>
  </BaseModal>
</template>


